module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/transform.js
// module id = 1058
// module chunks = 0